import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { ArrayUtil, ObjectUtil, StringUtil } from 'src/utils';

interface SummaryTypeDTO {
  id: string;
  name: string;
  type: string;
  count: number;
  firstTransactionDate: moment.Moment | null;
  lastTransactionDate: moment.Moment | null;
  //firstModifiedDate: moment.Moment | null;
  //lastModifiedDate: moment.Moment | null;
}
const SummaryTypeDTO = {
    create: (initValues?: Partial<SummaryTypeDTO>): SummaryTypeDTO => {
        const defaults: SummaryTypeDTO = {
      id: '',
      name: '',
      type: '',
      count: 0,
      firstTransactionDate: null,
      lastTransactionDate: null,
      //firstModifiedDate: null,
      //lastModifiedDate: null,
    };
        const fixedInitValues: Partial<SummaryTypeDTO> = initValues != null
      ? {
        id: StringUtil.IsNullOrEmpty(initValues.id) ? uuidv4() : initValues.id,
        firstTransactionDate: ObjectUtil.ToMoment(initValues.firstTransactionDate),
        lastTransactionDate: ObjectUtil.ToMoment(initValues.lastTransactionDate),
        //firstModifiedDate: ObjectUtil.ToMoment(initValues.firstModifiedDate),
        //lastModifiedDate: ObjectUtil.ToMoment(initValues.lastModifiedDate),
      }
      : {};
    return { ...defaults, ...initValues, ...fixedInitValues };
  },
};

export default SummaryTypeDTO;